import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["placeholder"];
const _hoisted_2 = {
    key: 0,
    class: "catalog-search-input__filters"
};
import { computed, ref, watch } from 'vue';
import { debounce } from 'lodash';
import CatalogSearchInputFilter from "./CatalogSearchInputFilter.vue";
import productRepository from "@astina/paloma-shop-common-ui/src/services/ProductRepository";
import portalConfig from "../services/PortalConfig";
import CatalogSearchInputSuggestions from "./CatalogSearchInputSuggestions.vue";
import { useRouter } from "vue-router";
import events from '@astina/paloma-common-ui/src/services/EventBus';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogSearchInput',
    props: {
        searchRequest: {},
        filters: {}
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const router = useRouter();
        const props = __props;
        const query = ref(props.searchRequest.query || '');
        const queryInputActive = ref(false);
        const showAllFilters = ref(false);
        const hasMoreFilters = computed(() => {
            return props.filters.length > portalConfig.catalog.search.initialFilterCount
                && !showAllFilters.value;
        });
        const visibleFilters = computed(() => {
            if (!showAllFilters.value && props.filters.length > portalConfig.catalog.search.initialFilterCount) {
                return props.filters.slice(0, portalConfig.catalog.search.initialFilterCount);
            }
            return props.filters;
        });
        watch(() => props.searchRequest.category, () => {
            query.value = '';
            suggestions.value = { products: [], categories: [] };
            showAllFilters.value = false;
        });
        function onQueryUpdate() {
            const sr = {
                query: query.value || undefined,
                filters: props.searchRequest.filters,
            };
            emit('update', sr);
            updateSuggestions();
        }
        const onQueryUpdateDebounced = debounce(onQueryUpdate, 300);
        watch(query, onQueryUpdateDebounced);
        const suggestions = ref({ products: [], categories: [] });
        const selectedSuggestion = ref(null);
        function updateSuggestions() {
            suggestions.value = { products: [], categories: [] };
            // disabled?
            if (!portalConfig.catalog.search.showCategorySuggestions) {
                return;
            }
            // only show suggestions if we are not inside a category,
            // because suggestions are not scoped to a category
            if (props.searchRequest.category) {
                return;
            }
            if (!query.value || query.value.length < 2) {
                return;
            }
            productRepository
                .listSuggestions(query.value)
                .then(data => suggestions.value = data);
        }
        function closeSuggestions() {
            suggestions.value = { products: [], categories: [] };
            selectedSuggestion.value = null;
        }
        function onFilterValueUpdated(filter, param) {
            const filters = [];
            const filterPropOrName = filter.name || filter.property;
            // keep other filters
            (props.searchRequest.filters || []).forEach(activeFilter => {
                if (activeFilter.property !== filterPropOrName) {
                    filters.push(activeFilter);
                }
            });
            // numeric range filter
            if (isNumericRangeFilter(filter)) {
                const range = param;
                if (range.min !== null || range.max !== null) {
                    const f = {
                        property: filterPropOrName,
                        greaterThan: range.min === null ? undefined : parseFloat('' + range.min),
                        lessThan: range.max === null ? undefined : parseFloat('' + range.max),
                    };
                    filters.push(f);
                }
                // boolean filter
            }
            else if (filter.type === 'bool') {
                if (param !== null) {
                    const value = !!param;
                    const f = {
                        property: filterPropOrName,
                    };
                    if (value) {
                        f.values = ["true", "1"];
                    }
                    else {
                        f.values = ["false", "0"];
                    }
                    filters.push(f);
                }
                // text + date range filter
            }
            else {
                const values = param;
                if (values.length > 0) {
                    const f = {
                        property: filterPropOrName,
                    };
                    f.values = values.map(v => v.valueCode || (v.value + ''));
                    filters.push(f);
                }
            }
            const sr = {
                query: props.searchRequest.query,
                filters: filters,
            };
            emit('update', sr);
        }
        function isNumericRangeFilter(filter) {
            return filter.type === 'currency'
                || filter.type === 'number';
        }
        function onSelectQueryInput() {
            queryInputActive.value = true;
        }
        function onBlurQueryInput() {
            queryInputActive.value = false;
            /**
             * Delay removing suggestions so we have the chance to click the link
             */
            window.setTimeout(() => {
                if (!queryInputActive.value) {
                    suggestions.value = { products: [], categories: [] };
                }
            }, 200);
        }
        function selectNextSuggestion() {
            const categories = suggestions.value.categories;
            if (categories.length === 0) {
                return;
            }
            if (selectedSuggestion.value === null) {
                selectedSuggestion.value = categories[0];
            }
            else {
                const index = categories.indexOf(selectedSuggestion.value);
                if (index === -1) {
                    selectedSuggestion.value = categories[0];
                }
                else if (index < (categories.length - 1)) {
                    selectedSuggestion.value = categories[index + 1];
                }
            }
        }
        function selectPrevSuggestion() {
            const categories = suggestions.value.categories;
            if (categories.length === 0) {
                return;
            }
            if (selectedSuggestion.value === null) {
                selectedSuggestion.value = categories[categories.length - 1];
            }
            else {
                const index = categories.indexOf(selectedSuggestion.value);
                if (index === -1) {
                    selectedSuggestion.value = categories[categories.length - 1];
                }
                else if (index > 0) {
                    selectedSuggestion.value = categories[index - 1];
                }
            }
        }
        function trackSuggestion(category) {
            events.$emit('track.home_suggestion', {
                query: query.value.trim(),
                type: 'suggest-category',
                name: category.name,
                route: { name: 'catalog_category', params: { category: category.code } }
            });
        }
        function onSuggestionClick(category) {
            trackSuggestion(category);
            closeSuggestions();
        }
        function onSearchQueryInputEnter() {
            if (selectedSuggestion.value !== null) {
                trackSuggestion(selectedSuggestion.value);
                router.push({
                    name: 'catalog_category',
                    params: { category: selectedSuggestion.value.code }
                });
            }
            else {
                const q = query.value.trim();
                if (q) {
                    events.$emit('track.home_search', { query: q, type: 'enter' });
                }
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"])),
                class: "catalog-search-input"
            }, [
                _withDirectives(_createElementVNode("input", {
                    type: "search",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((query).value = $event)),
                    placeholder: _ctx.$t('search.placeholder'),
                    class: "catalog-search-input__query",
                    tabindex: "0",
                    name: "query",
                    onClick: onSelectQueryInput,
                    onBlur: onBlurQueryInput,
                    onKeydown: [
                        _withKeys(selectNextSuggestion, ["down"]),
                        _withKeys(selectPrevSuggestion, ["up"])
                    ],
                    onKeyup: _withKeys(onSearchQueryInputEnter, ["enter"])
                }, null, 40, _hoisted_1), [
                    [
                        _vModelText,
                        query.value,
                        void 0,
                        { trim: true }
                    ]
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createVNode(CatalogSearchInputSuggestions, {
                    suggestions: suggestions.value,
                    selected: selectedSuggestion.value,
                    onClose: closeSuggestions,
                    onSelect: onSuggestionClick
                }, null, 8, ["suggestions", "selected"]),
                _cache[6] || (_cache[6] = _createTextVNode()),
                (__props.filters.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleFilters.value, (filter) => {
                            return (_openBlock(), _createBlock(CatalogSearchInputFilter, {
                                filter: filter,
                                key: filter.name,
                                onUpdate: onFilterValueUpdated,
                                "search-request": __props.searchRequest
                            }, null, 8, ["filter", "search-request"]));
                        }), 128)),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        (hasMoreFilters.value)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (showAllFilters.value = true), ["prevent"])),
                                class: "catalog-search-input__filters-toggle",
                                href: ""
                            }, _toDisplayString(_ctx.$t('catalog.search_filters.show_all')), 1))
                            : (showAllFilters.value)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (showAllFilters.value = false), ["prevent"])),
                                    class: "catalog-search-input__filters-toggle",
                                    href: ""
                                }, _toDisplayString(_ctx.$t('catalog.search_filters.show_less')), 1))
                                : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ], 32));
        };
    }
});
